import moment from 'moment';

const formatNum = (num, digits = 1) => {
  const units = ['k', 'M', 'G', 'T', 'P', 'E', 'Z', 'Y'];
  const floor = Math.floor(Math.abs(num).toString().length / 3);
  const value = +(num / 1000 ** floor);
  return value.toFixed(value > 1 ? digits : 2) + units[floor - 1];
};

const convertTimestampToDate = (t) => {
  return moment.unix(t).format('MMM YYYY');
};

const convertIntoTitleCase = (str) => {
  return str.replace(/\w\S*/g, function upperCaseTitle(txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

const formatUsPhone = (phoneNumber) => {
  return phoneNumber.replace(/\D+/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '$1 $2 $3');
};

const isObjEmpty = (obj) => Object.keys(obj).length === 0;

const updateNcbData = (IndicatorType, values, savedValues, url, strategyId) => {
  const payload = { ...values };
  payload.indicatorName = IndicatorType.filter((ind) => ind.value === values.indicatorType)[0].label;
  payload.url = `/no-code-builder/${strategyId}/${url}/${values.indicatorType}`;

  const updatedIndicator = [...savedValues];
  const savedIndicator = savedValues.findIndex((direInd) => direInd.indicatorType === values.indicatorType);

  if (savedIndicator > -1) updatedIndicator[savedIndicator] = payload;
  else updatedIndicator.push(payload);

  return updatedIndicator;
};

/* eslint-disable import/prefer-default-export */
export { formatNum, convertTimestampToDate, convertIntoTitleCase, formatUsPhone, isObjEmpty, updateNcbData };
